import { Partytown } from '@builder.io/partytown/react';
import { Env, useComplianceProvider, useInfraContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';
import { partytownConfig as gtmPartytownConfig, useGTM } from './hooks/useGTM';
import { partytownConfig as segmentPartytownConfig, useSegment } from './hooks/useSegment';

interface AnalyticsProps {
  readonly isPartytownEnabled: boolean;
}

export const Analytics: React.FC<AnalyticsProps> = ({ isPartytownEnabled }) => {
  const { env } = useInfraContext();
  const { cookieTypesEnabledList } = useComplianceProvider();
  const isProductionOrStagingEnv = env === Env.Production || env === Env.Staging;

  const isGtmEnabled = isProductionOrStagingEnv && cookieTypesEnabledList.includes('analytics');
  const isSegmentEnabled = isProductionOrStagingEnv && cookieTypesEnabledList.includes('performance');

  useGTM({ enabled: isGtmEnabled, isPartytownEnabled });
  useSegment({ enabled: isSegmentEnabled, isPartytownEnabled });

  useEffect(() => {
    if (isProductionOrStagingEnv) return;

    /* eslint-disable no-console */
    window.analytics = {
      ready: () => console.log('mocking analytics'),
      track: console.log,
    };
    /* eslint-enable no-console */
  }, [isProductionOrStagingEnv]);

  if (isPartytownEnabled)
    return (
      <Partytown
        forward={[...(isGtmEnabled ? gtmPartytownConfig : []), ...(isSegmentEnabled ? segmentPartytownConfig : [])]}
        resolveUrl={(url: URL) => {
          const proxyMap = JSON.parse(process.env.PARTYTOWN_PROXY_MAP ?? '{}') as Record<string, string>;

          url.hostname = proxyMap[url.hostname] || url.hostname;
          return url;
        }}
      />
    );

  return null;
};
